export const MENU_ALIGN = {
    LEFT: 'left',
    RIGHT: 'right',
};

export const MENU_ALIGNS = Object.values(MENU_ALIGN);

export const MENU_ITEM_TONE = {
    DEFAULT: 'default',
    DANGER: 'danger',
};

export const MENU_ITEM_TONES = Object.values(MENU_ITEM_TONE);

// The tick on the chosen option (design: a check at the row's end).
export const MENU_SELECTED_ICON = 'check';
